// 앱 전역 MUI 테마 (Login 화면 포함 전 화면 공용)
import { createTheme } from '@mui/material';
import { PaletteOptions, Palette } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    infoText: Palette['primary'];
  }

  interface PaletteOptions {
    infoText?: PaletteOptions['primary'];
  }
}

export const appTheme = createTheme({
  palette: {
    primary: {
      main: '#FF000070',
    },
    secondary: {
      main: '#FFFFFF',
    },
    infoText: {
      main: '#FF0000F0',
    },
  },
});
